export default __webpack_public_path__ + "static/media/chevron_right.b6d6d067.svg";